import headerImg from "../images/headerImg.png";
import section2 from "../images/Section2.png";
import section3 from "../images/section3.png";
import section4 from "../images/section4.png";
import tick_icon from "../images/tick-icon.png";
import Faqs from "./FAQs";
import Testimonials from "../components/testimonial";
import Form from "../components/form";
import google from '../images/Google.png'
import Facebookimg from '../images/Facebookimg.png'
import Pinterest from '../images/Pinterest.png'
import Twitch from '../images/Twitch.png'
import YouTube from '../images/YouTube.png'
import webflow from '../images/Webflow.png'



// =========Secion6========== (How it works)
const steps = [
  {
    step: "01",
    title: "Initial assessment",
    description:
      "Evaluate the patient's medical history, symptoms, and treatment goals to determine suitability for weight management intervention.",
  },
  {
    step: "02",
    title: "Choose Tablets or Injections",
    description:
      "Select the appropriate medication form based on patient preference, clinical indications, and potential side effects.",
  },
  {
    step: "03",
    title: "Tier 1 or Tier 2 pathway.",
    description:
      "Decide between a Tier 1 (standard support) or Tier 2 (enhanced multidisciplinary support) approach, depending on patient needs and complexity.",
  },
  {
    step: "04",
    title: "Ongoing support + maintenance.",
    description:
      "Provide regular follow-ups, monitor progress, manage side effects, and support long-term lifestyle changes to maintain results.",
  },
];

// =====Section 3 & 4====== (Tablets / Injections)
const weightSections = [
  {
    id: "tablets",
    badge: "Tablets",
    bg: "bg-white",
    image: section3,
    alt: "Weight loss tablets",
    reverse: false,
    title: `Let us help you find the right weight loss medication for you.`,
    description: `With 40 years’ experience in weight loss, our doctors and health professionals are here to support your journey to a happier, healthier you.`,
  },
  {
    id: "injections",
    badge: "Injections",
    bg: "bg-[#FAFAFA]",
    image: section4,
    alt: "Weight loss injections",
    reverse: true,
    title: `Let us help you find the right weight loss medication for you.`,
    description: `With 40 years’ experience in weight loss, our doctors and health professionals are here to support your journey to a happier, healthier you.`,
  },
];

// =========Section5============== (Two-tier care plans)
const carePlans = [
  {
    id: "self",
    title: "Self-Managed Plan",
    summary:
      "Motivated individuals comfortable managing their own journey with minimal supervision.",
    features: [
      "Self-guided treatment using approved medications (tablets or injections)",
      "Access to educational resources and lifestyle guidance",
      "Optional doctor consultations (book as needed)",
      "Cost-effective and flexible",
    ],
  },
  {
    id: "doctor",
    title: "Doctor-Led Subscription Plan",
    summary:
      "Those who want ongoing professional support and regular monitoring.",
    features: [
      "Monthly doctor reviews and treatment adjustments",
      "Progress tracking and personalized care",
      "Ongoing medical support via subscription",
      "Regular medication and lifestyle plan optimization",
    ],
  },
];

// ========ection2============/
const logos = [
  { src: google, alt: "Google" },
  { src: Facebookimg, alt: "Facebook" },
  { src: YouTube, alt: "YouTube" },
  { src: Pinterest, alt: "Pinterest" },
  { src: Twitch, alt: "Twitch" },
  { src: webflow, alt: "Webflow" },
];

const Front = () => {
  return (
    <>
      <div className="overflow-x-hidden">
        {/* ========== HERO SECTION ========== */}
        <section className="bg-white font-poppins overflow-x-hidden">
          <div className="max-w-7xl mx-auto px-2 lg:px-2 py-16 flex flex-col md:flex-row items-center gap-12">

            <div className="w-full md:w-1/2">
              <h1
                className="font-black tracking-[-0.02em] text-[#2A3342] leading-[60px] 
             text-[26px] sm:text-[30px] md:text-[38px] lg:text-[55px]"
              >
                Specialist Weight
                <br />
                Loss Doctor Led Clinic
              </h1>

              <p className="mt-6 text-[16px] leading-relaxed text-[#556987] max-w-lg">
                We all have been told that the secret to losing weight is ‘eating less and moving more’.
                However, losing weight can be a complex process, and often people get lost in this simplistic advice.
                Let us take away all the confusion and guide you through every step of the way.
              </p>

              <div className="mt-8 flex flex-wrap items-center gap-4">
                <button className="px-8 py-3 text-[18px] font-medium rounded bg-[#56C7D5] text-white shadow-sm">
                  Get Started
                </button>

                <button className="px-8 py-3 text-[18px] font-medium rounded border border-[#56C7D5] text-[#56C7D5] bg-white hover:bg-[#F5FFFD] transition">
                  Shop Online
                </button>
              </div>
            </div>

            <div className="w-full md:w-1/2 flex justify-center md:justify-end">
              <img
                src={headerImg}
                alt="Doctor in clinic"
                className="w-full max-w-[480px] md:max-w-[520px] rounded-2xl object-cover"
              />
            </div>
          </div>
        </section>

        {/* ========== FULL-WIDTH IMAGE ========== */}
        <img
          src={section2}
          alt="Section Image"
          className="w-full h-auto object-cover"
        />

        {/* ========== TABLETS / INJECTIONS SECTIONS (3 & 4) ========== */}

        {weightSections.map((item) => (
          <section key={item.id} className={`${item.bg} py-16 font-poppins`}>
            <div
              className={`max-w-7xl mx-auto px-6 lg:px-2 flex flex-col md:flex-row items-center gap-12 ${item.reverse ? "md:flex-row-reverse" : ""
                }`}
            >
              <div className="w-full md:w-1/2">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full rounded-2xl shadow-sm object-cover"
                />
              </div>

              {/* Text */}
              <div className="w-full md:w-1/2">
                <div className="inline-block bg-[#DCFCE7] text-[#56C7D5] text-[12px] font-semibold px-3 py-1 rounded-full mb-4">
                  {item.badge}
                </div>

                <h2 className="text-[32px] sm:text-[36px] md:text-[42px] lg:text-[46px] font-bold text-[#2A3342] leading-tight mb-6">
                  {item.title}
                </h2>

                <p className="text-[#556987] leading-relaxed text-[16px] max-w-md">
                  {item.description}
                </p>
              </div>
            </div>
          </section>
        ))}

        {/* ========== TWO-TIER CARE MODEL (SECTION 5) ========== */}

        <section className="py-10 font-poppins">
          <div className="max-w-7xl mx-auto px-4 md:px-6">

            <div className="text-center">
              <h2 className="text-[32px] md:text-[36px] lg:text-[48px] font-bold text-[#2A3342]">
                Two-Tier Care Model
              </h2>
              <p className="mt-4 text-[14px] md:text-[15px] lg:text-[17px] text-[#556987] mx-auto leading-relaxed">
                Our weight management program offers a flexible two-tier model
                designed to suit different levels of support and engagement.
                Choose the pathway that best aligns with your lifestyle, medical
                needs, and personal preferences.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2">
              {carePlans.map((plan) => (
                <div
                  key={plan.id}
                  className="bg-white rounded border border-slate-100 shadow-sm m-6 md:m-[4rem] p-7 md:p-8 lg:p-[26px]"
                >
                  <h3 className="text-[23px] font-semibold text-[#2A3342] mb-3">
                    {plan.title}
                  </h3>

                  <p className="text-[13px] md:text-[14px] lg:text-[16px] text-[#556987] mb-5 leading-relaxed">
                    {plan.summary}
                  </p>

                  <ul className="space-y-3">
                    {plan.features.map((feature) => (
                      <FeatureItem key={feature}>{feature}</FeatureItem>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ========== HOW IT WORKS (SECTION 6) ========== */}

        <section className="pb-16 font-poppins">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="text-center text-[32px] md:text-[36px] lg:text-[48px] font-bold text-[#2A3342] mb-12">
              How It Works
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {steps.map((item) => (
                <div
                  key={item.step}
                  className="bg-white border border-slate-100 px-6 py-8 rounded flex flex-col h-full"
                  style={{
                    boxShadow: `
              0px 4px 6px -4px rgba(0,0,0,0.10),
              0px 10px 15px -3px rgba(0,0,0,0.10)
            `,
                  }}
                >
                  <p className="text-[16px] font-medium text-[#56C7D5] mb-1">
                    Step{" "}
                    <span className="text-[#56C7D5] font-semibold text-2xl">
                      {item.step}
                    </span>
                  </p>

                  <h3 className="text-[17px] font-semibold text-[#2A3342] mb-2 mt-3 leading-snug min-h-[50px]">
                    {item.title}
                  </h3>

                  <p className="text-[16px] leading-relaxed text-[#556987] flex-grow">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ========== FAQS, TESTIMONIALS, FORM (SECTION 7+) ========== */}
        <Faqs />
        <Testimonials />
        <Form />
      </div>
    </>
  );
};

export default Front;

// ========= Reusable Feature Item ========== //
const FeatureItem = ({ children }) => (
  <li className="flex items-start gap-3">
    <img
      src={tick_icon}
      alt="tick"
      className="mt-1 h-5 w-5 shrink-0 object-contain"
    />
    <span className="text-[16px] leading-relaxed text-[#556987]">
      {children}
    </span>
  </li>
);
